import React, { useEffect, useState } from "react";
import {Modal, Button} from 'react-bootstrap';
import { useSelector } from "react-redux";
import ConfirmationModal from '../Controls/ConfirmationModal';
import APICom from "../../utils/helpers/APICom";
import "../../assets/Styles/UnAssignCSS/UnAssignCSS.css";

const UnAssignAction = (props) => {

    const { loginData }  = useSelector((store) => store.login);
    const { ASCSSettingData }  = useSelector((store) => store.combinedata);
    const [isComponentLoading, setIsComponentLoading] = useState(true);
    const [showUnAssignAlert, setShowUnAssignAlert] = useState(false);
    const [unAssignAlert, setUnAssignAlert] = useState({alertTitle : '', alertMsg: ''});
    const [forceUnAssign, setForceUnAssign] = useState(false);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Confirm Un-Assign?',
    body:'This request has already been marked as Picked-Up. Would you still like to Un-Assign this trip?', btnCanceText: 'No',
    btnOkText: 'Yes'});
    const[WMRUrl, setWMRUrl] = useState('');
    const[TCGWaitT, setTCGWaitT] = useState("35"); 

    useEffect(() => {
        if(props.GridRowData === null || props.GridRowData.length <= 0)
        {
            setUnAssignAlert({...unAssignAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to assign.'});
            setShowUnAssignAlert(true);
        }
        else
        {
            UnAssign();
        }
    }, []);

    const UnAssign = () => {
        if(forceUnAssign === false && props.GridRowData[0].TripRequestStatus === "PICKEDUP")
            {
                setConfirmationModalObj((prevState) => ({...prevState, show:true}));
            }
            else
            {
                var lstGlobalData = {
                    "ServiceID": "",
                    "ScheduleID": "",
                    "AssignedVehicleId": "",
                    "AssignedDriverId": "",
                    "MultipleClusterMode": "",
                    "NoOfESR": "",
                    "RequestDate": "",
                    "ManifestNumber": "",
                    "TripRequestStatus": "",
                    "ScheduleDetailIDs": ""
                }
                var Param = {
                    "lstGlobalData": [],
                    "ActionAssignedVehicleId": "",
                    "ActionAssignedDriverId": "",
                    "ManifestNumber": "",
                    "iUserID":"",
                    "iATSPID": "-1",
                    "WMRUrl":"",
                    "TCGWaitT" : "35",
                    "iAppID": ""
                }

                if(ASCSSettingData !== null && ASCSSettingData !== undefined)
                {
                    if (ASCSSettingData.hasOwnProperty(props.GridRowData[0].iSRATSPID)) {
                      const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[props.GridRowData[0].iSRATSPID]); // Parse JSON string into an array
                      for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
                      {
                            if(ascsSettingDataByAffiliate[i]["SubTitle"] === "WMRAPIURL")
                            {
                                setWMRUrl(ascsSettingDataByAffiliate[i]["value"]);
                            }
                            if(ascsSettingDataByAffiliate[i]["SubTitle"] === "TCGWaitT")
                            {
                                setTCGWaitT(ascsSettingDataByAffiliate[i]["value"]);
                            }
                      }
                    }
                }
                Param = FillMultiSelectionActionobjects();
                Param["iUserID"] = loginData.iUserID;
                Param["WMRUrl"] = WMRUrl;
                Param["TCGWaitT"] =TCGWaitT
                Param["iAppID"] ="26"
                if(Param !== null && Param !== "")
                {
                     UnAssignAction(Param);
                }

            }
    }

    const UnAssignAction = async (Param) => {
        console.log(Param);
        let response = await APICom.fetchData("", "TripActions/PerformUnAssignAffiliate", "post", { "Content-Type": "application/json" }, Param, null);
        if(response.data["result"] == "true")
        {
            setUnAssignAlert({...unAssignAlert, alertTitle: 'Un-Assign Affiliate Action', alertMsg:'Affiliate un-assigned successfully.'});
            setShowUnAssignAlert(true);
        }
        else
        {
            UnMountUnAssignActionComponent();
        }
    }

    const FillMultiSelectionActionobjects = () => {

        var Param = {
            "lstGlobalData": [],
            "ActionAssignedVehicleId": "",
            "ActionAssignedDriverId": "",
            "ManifestNumber": "",
            "iUserID":"",
            "iATSPID": "-1",
            "WMRUrl":"",
            "TCGWaitT" : "35"
        }
    
        try {
            var ProssedRecordList = new Array();
            var ProssedManifestList = new Array();
            var SelectedRecords = props.GridRowData;
    
            for (var k = 0; k < SelectedRecords.length; k++) {
                var MKPMs = {
                    "ServiceID": "", "ScheduleID": "-1", "AssignedVehicleId": "-1", "AssignedDriverId": "-1", "MultipleClusterMode": "",
                    "NoOfESR": "", "RequestDate": "", "ManifestNumber": "", "TripRequestStatus": "", "ScheduleDetailIDs": "", "MSchWC" : ""
                }
    
                try {
                    if (SelectedRecords[k].vManifestNumber === null || SelectedRecords[k].vManifestNumber.toString().trim() === "") {
                        if (SelectedRecords[k].bIsSchedule.toString().toLowerCase() === "true") {
                            MKPMs.ScheduleID = ((SelectedRecords[k].iScheduleID === null || SelectedRecords[k].iScheduleID.toString().trim() === "") ? "-1" : SelectedRecords[k].iScheduleID.toString());
                        }
                        MKPMs.ServiceID = SelectedRecords[k].ServiceID.toString();
                        MKPMs.ScheduleDetailIDs = SelectedRecords[k].SchDetailID.toString().trim();
                        MKPMs.MSchWC = ((SelectedRecords[k].PickupTime === "MSchWC") ? "true" : "false");
                    }
                    else if (!ProssedManifestList.includes(SelectedRecords[k].vManifestNumber)) {
                        Param.ManifestNumber += SelectedRecords[k].vManifestNumber.toString() + ",";
                        ProssedManifestList.push(SelectedRecords[k].vManifestNumber);
                    }
    
                    MKPMs.AssignedVehicleId = (SelectedRecords[k].iAssignedVehicleId === null) ? '-1': String(SelectedRecords[k].iAssignedVehicleId);
                    MKPMs.AssignedDriverId = (SelectedRecords[k].AssignedDriverId === null)? '-1' : String(SelectedRecords[k].AssignedDriverId);
                    MKPMs.TripRequestStatus = SelectedRecords[k].TripRequestStatus;
                    MKPMs.Queue = "";
    
                    ProssedRecordList.push(SelectedRecords[k].ConfirmationNo);
    
                    Param.lstGlobalData.push(MKPMs);
                }
                catch (abc) { console.log(abc); }
            }
    
            try {
                if (!ProssedRecordList.includes(SelectedRecords[0].ConfirmationNo)) {
    
                    var MKPMs = {
                        "ServiceID": "", "ScheduleID": "", "AssignedVehicleId": "", "AssignedDriverId": "", "MultipleClusterMode": "",
                        "NoOfESR": "", "RequestDate": "", "ManifestNumber": "", "TripRequestStatus": "", "ScheduleDetailIDs": "", "MSchWC": ""
                    }
                    MKPMs.Queue = "";
                    try {
                        if ((SelectedRecords[0].vManifestNumber === null || SelectedRecords[0].vManifestNumber.toString() === "")) {
                            if (SelectedRecords[0].bIsSchedule.toString().toLowerCase() === "true") {
                                MKPMs.ScheduleID = ((SelectedRecords[0].iScheduleID === null || SelectedRecords[0].iScheduleID.toString() === "") ? "-1" : SelectedRecords[0].iScheduleID);
                            }
                            MKPMs.ServiceID = SelectedRecords[0].ServiceID;
                            MKPMs.ScheduleDetailIDs = SelectedRecords[k].SchDetailID.toString().trim();
                            MKPMs.AssignedVehicleId = String(SelectedRecords[0].iAssignedVehicleId);
                            MKPMs.AssignedDriverId = String(SelectedRecords[0].AssignedDriverId);
                            MKPMs.TripRequestStatus = SelectedRecords[0].TripRequestStatus;
                            MKPMs.MSchWC = ((SelectedRecords[k].PickupTime === "MSchWC") ? "true" : "false");
                            MKPMs.Queue = "";
    
                        }
                        else if (!ProssedManifestList.includes(SelectedRecords[0].vManifestNumber)) {
                            ProssedRecordList.push(SelectedRecords[0].vManifestNumber);
                        }
                    }
                    catch (afw) { }
                }
    
            }
            catch (asd) { }
        } catch (FillMultiSelectionActionobjectsException) { console.log(FillMultiSelectionActionobjectsException); }
    
        return Param;
    }

    useEffect(() => {
        if(isComponentLoading)
        {
            setIsComponentLoading(false);
            return;
        }
        UnAssign();
    }, [forceUnAssign])

    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        setForceUnAssign(true);
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    }
    
    const handleUnAssignAlertModalClose = () => {
        setShowUnAssignAlert(false);
        UnMountUnAssignActionComponent();
    }

    const UnMountUnAssignActionComponent = () => {
        if(props.invokeUnAssignComponent)
        {
            props.setUnAssignProcessing(false);
            props.RefreshGridData();
            props.setInvokeUnAssignComponent(false);
        }
    }

    return(
        <>
        <Modal centered show={showUnAssignAlert}  animation={false} >
                                  <Modal.Header className='unassign_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                                    <Modal.Title className="unassign_dialog_title_color">{unAssignAlert.alertTitle}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body><b>{unAssignAlert.alertMsg}</b></Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handleUnAssignAlertModalClose}>
                                      Close
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
        <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
        onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} btnCanceText={confirmationModalObj.btnCanceText}
        btnOkText={confirmationModalObj.btnOkText} />
        </>
    );
}

export default UnAssignAction;